<template>

  <loader v-if="loading"/>

  <div v-else>

    <div
      class="py-2"
      v-for="(item, index) in list_data"
      :key="index">

      <h6 class="mb-2"> {{item.client_name}}</h6>

      <campaignMonitorList
        v-for="(list, index) in item.lists"
        @update="({data, key}) => {updateParams(data, key, item.client_id)}"
        :triggerUpdate="updateChild"
        :key="index"
        :open="index === 0"
        :list="list"
        :client_id="item.client_id"
        :sync_fields="sync_fields[list.id]"
        :wallkit_fields="wallkit_fields"/>

    </div>

    <div class="d-flex w-100 justify-content-end">

      <b-button
        :disabled="!params.length"
        @click="debounceUpdateCampaignMonitor">
        {{$t('button.update')}}
      </b-button>

    </div>

  </div>

</template>

<script>
  import campaignMonitorList from './campaignMonitorList';
  import {findIndex, debounce, orderBy} from 'lodash';

  export default {
    name: "CampaignMonitorClients",
    props: {
      resources_key: {
        type: String
      },
      synchronize: false
    },
    components: {campaignMonitorList},
    data() {
      return {
        list_data: [],
        wallkit_fields: [],
        sync_fields: [],
        params: [],
        updateChild: false,
        loading: false,
        debounceUpdateCampaignMonitor : () => {},
        debounceGetServiceData : () => {},
      }
    },
    created() {
      this.getServiceData(false);
      this.debounceUpdateCampaignMonitor = debounce(this.updateCampaignMonitor, 500);
      this.debounceGetServiceData = debounce(this.getServiceData, 500);
    },
    methods: {
      async getServiceData(update) {
        try {
          this.loading = true;
          const {data: {campaignmonitor_data, wallkit_fields, sync_fields}} = await this.getData(`resources/${this.resources_key}/campaignmonitor`, {
            params: {update: update}
          });

          this.list_data = campaignmonitor_data;
          this.wallkit_fields = wallkit_fields;
          this.sync_fields = sync_fields;
          this.loading = false;

        } catch (err) {
          console.log(err);
          this.loading = false;
        }
      },
      updateParams(data, key, client_id) {
        let index = findIndex(this.params, (list) => {
          return list.list_id === key
        });

        let params = Object.assign({}, data);
        params.client_id = client_id;

        if (index !== -1) {
          this.$set(this.params, index, params);
        } else {
          this.$set(this.params, this.params.length, params);
        }

      },
      async updateCampaignMonitor() {
        try {
          if (!!this.params.length) {
            this.loading = true;
            const {data: {campaignmonitor_data, wallkit_fields, sync_fields}} = await this.putData(`resources/${this.resources_key}/campaignmonitor`,
                {campaignmonitor_data: this.params});

            this.list_data = campaignmonitor_data;
            this.wallkit_fields = wallkit_fields;
            this.sync_fields = sync_fields;

            this.loading = false;
          }
        } catch (err) {
          console.log(err);
          this.loading = false;
        }
      }
    },
    watch: {
      synchronize() {
        this.debounceGetServiceData(true);
      }
    }
  }
</script>
